<footer id="main-footer">
<div class="footer-content">
    <div class="container pt-5 pb-5">
      <div class="row p-0 m-0">
        <div class="col-lg-3 col-md-4 col-sm-4">
          <div class="footer-text">
            <h4 >Informations</h4>
          <ul class="footerList mt-2">
            <li>
              <a href="{{strBlogUrl}}about-us">About Us</a>
            </li>
            <li>
              <a href="{{strBlogUrl}}contact-us">Contact Us</a>
            </li>
            <li>
              <a href="{{strBlogUrl}}privacy-policy/">Privacy Policy</a>
            </li>
            <li>
              <a href="{{strBlogUrl}}terms-of-use/">Terms And Conditions</a>
            </li>
          </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-4 footer-text">
            <h4>WickedList</h4>
          <ul class="footerList mt-2">
            <li *ngIf="enableCompareVersion">
              <a style="cursor: pointer" (click)="showCompareVersionsDialog()" >Compare versions</a>
            </li>
            <li>
              <a  href="{{ enableAdvertiseWithUs ? '/adv-with-us' : '/b/contact-us'}}" >Advertise With Us</a>
            </li>

            <li *ngIf="enableSubscription">
              <a routerLink="/subscription-information">Subscription</a>
            </li>


          </ul>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-4  footer-text">
          <h4 >Quick Links</h4>
          <ul class="footerList mt-2">

            <li>
              <a href="{{strBlogUrl}}blog/">Blog</a>
            </li>

            <li>
              <a href="{{strBlogUrl}}dating-tips/">Dating Tips</a>
            </li>
            <li *ngIf="enableLetOurPros">
              <a  routerLink="/ad-writter" style="color: #ff4081; font-weight: bold;" >Let one of our Pros write Your ad for You</a>
            </li>
            <!-- <li>
    <a href="{{strBlogUrl}}pricing-table/">Pricing table (example)</a>
  </li>-->

          </ul>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12  footer-text footer-socialmedia">
          <div class="w-100 pt-0 "><img style="max-height:60px" src="https://wickedlist.com/footer-logo.png"></div>
          <ul class="et-social-icons">

              <li class="et-social-icon et-social-facebook">
                <a rel="noreferrer" href="https://www.facebook.com/WickedListDating" class="icon" target="_blank">
                  <span>Facebook</span>
                </a>
              </li>
              <li class="et-social-icon et-social-twitter">
                <a rel="noreferrer" href="https://twitter.com/WickedList" class="icon" target="_blank">
                  <span>Twitter</span>
                </a>
              </li>
              <li class="et-social-icon et-social-instagram">
                <a rel="noreferrer" href="https://www.instagram.com/wickedlistdating/" class="icon" target="_blank">
                  <span>Instagram</span>
                </a>
              </li>
            </ul>
        </div>
      </div>
    </div>
</div>
<div class="footer-resume">
  <div class="container pt-3 pb-3">
    &copy; Wickedlist.com 2017 - {{currentYear}} All Rights Reserved
  </div>
</div>
</footer>
